

import { Box, List, ListItem, Typography } from "@mui/material";
import CreateNewJobSidebarItems from "@/Config/Export/CreateNewJob/CreateNewjobsidebar";
import { useUser } from "@/Context/UserContext";
import { useEffect, useState } from "react";
import { applyDynamicRules } from "@/Utils/Rules/ApplyConditions";

const SidebarMenu = ({ activeIndex, setActiveIndex }) => {
  const handleItemClick = (index, disabled) => {
    if (!disabled) {
      setActiveIndex(index);
    }
  };
  const {
    formData
  } = useUser();
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const items = CreateNewJobSidebarItems(formData); // send the formData to process disable/ enable the tabs
    const updatedItems = applyDynamicRules(items, formData); // apply dynamic rules
    setSidebarItems(updatedItems);

    const currentItem = updatedItems[activeIndex];
    if (currentItem?.disabled) {
      // Move to first enabled tab (or you can pick previous)
      const firstEnabledIndex = updatedItems.findIndex(item => !item.disabled);
      if (firstEnabledIndex !== -1) {
        setActiveIndex(firstEnabledIndex);
      }
    }
  }, [formData]);

  return (
    <Box
      sx={{
        width: 200,
        // height: "60vh",
        bgcolor: "var(--gray-0)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",

          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--gray-400)",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        <List disablePadding>
          {sidebarItems.map((item, index) => {
            const isActive = activeIndex === index;
            const isDisabled = item.disabled;
            return (
              <ListItem
                key={index}
                disableGutters
                onClick={() => !isDisabled && handleItemClick(index)}
                sx={{
                  bgcolor: isActive ? "var(--brand-100)" : "transparent",
                  borderLeft: isActive
                    ? "6px solid var(--green-100)"
                    : "6px solid transparent",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.5 : 1,
                  px: 1.5,
                  py: 1.2,
                  padding: 2,
                }}
              >
                <Typography fontWeight={isActive ? "600" : " 400"}>
                  {item.label}
                </Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};

export default SidebarMenu;



